export default __webpack_public_path__ + "static/img/6.c89fab5.png";